import React, { Component } from "react"
import { connect } from 'react-redux'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";

import { msg } from '../../components/Notifications/MsgBox';

import {
    getCostCenterAction,
} from '../../redux/actions/MasterAction'
import {
     EVENT_COST_CENTER_SELECTED
} from '../../configs/EventTypes'

import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction.js"

class SearchCostCenterModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            // ...props,
            q_costCenter: "",
            q_isDummy: "",
            q_offset: 1,
            q_limit: 10,
            costCenterDatas: [],
            page: 0,
            rowsPerPage: 5,
            totalRecord:0,
            order: "asc",
            orderBy: "",
        }
        this.handleClick = this.handleClick.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.selecctCostCenter = this.selecctCostCenter.bind(this)
    }

    selecctCostCenter(obj){
        const {refKey}=this.props
        // if(this.props.onSelectCC){
        //     this.props.onSelectCC(obj.cosT_CENTER)
        // }
        
        window.emitter.emit(EVENT_COST_CENTER_SELECTED, refKey,obj.cosT_CENTER)

        // if(window.onCostCenterSelected){
        //     window.onCostCenterSelected(refKey,obj.cosT_CENTER)
        // }

        window.$('#searchCostCenterModal').modal('hide')
    }

    handleChange(event) {
        const { name, value } = event.target
        this.setState({
            [name]: value,
        })
    }

    handleClick(event, newPage) {
        let { q_costCenter, page, rowsPerPage } = this.state;
        this.props.startLoading()
        
        if(newPage)
        {
            page = newPage
        }else{
            page = 0
        }
        this.props.getCostCenter(q_costCenter, page * rowsPerPage, rowsPerPage)
            .then(response => {
                if (response.data != null && response.data.length > 0) {
                    this.setState({
                        costCenterDatas: response.data,
                        totalRecord: response.data[0].totaL_ROW,
                        page:page,
                        rowsPerPage: rowsPerPage
                    })
                } else {
                    msg.error("ไม่พบข้อมูล")
                }

                this.props.stopLoading()
            });

    }
    // Grid start

    desc(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    stableSort(array, cmp) {
        if (typeof (array) !== "undefined") {
            const stabilizedThis = array.map((el, index) => [el, index]);
            stabilizedThis.sort((a, b) => {
                const order = cmp(a[0], b[0]);
                if (order !== 0) return order;
                return a[1] - b[1];
            });
            return stabilizedThis.map(el => el[0]);
        }
    }

    getSorting(order, orderBy) {
        return order === "desc"
            ? (a, b) => this.desc(a, b, orderBy)
            : (a, b) => -this.desc(a, b, orderBy);
    }

    handleRequestSort(event, property) {
        const isDesc = this.state.orderBy === property && this.state.order === "desc";
        this.setState({
            order: isDesc ? "asc" : "desc",
            orderBy: property
        })
    }

    async handleChangePage(event, newPage) {
        await this.setState({
            page: newPage
        })
        this.handleClick(event, newPage)
    }

    async handleChangeRowsPerPage(event) {
        await this.setState({
            rowsPerPage: event.target.value,
            page: 0
        })
        this.handleClick()
    }

    // Grid end

    render() {
        let {costCenterDatas, q_costCenter, page, rowsPerPage, totalRecord,order,orderBy} = this.state
        
        return (
            <div className="modal fade sp-modal rrs-modal" id="searchCostCenterModal" tabIndex={-1} role="dialog" aria-labelledby="searchCostCenterModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchCostCenterModalLabel">ค้นหาข้อมูล Cost Center</h5>
                            <button type="button" className="close" onClick={()=>window.$('#searchCostCenterModal').modal('hide')} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container" style={{paddingTop:"10px"}}>
                            <div className="rrs-detail3">
                                <div className="row" style={{paddingBottom:"10px"}}>
                                    <div className="col-7">
                                        <div className="rrs-form">

                                            <label htmlFor="txtEmpCode" className="rrs-label">Cost Center</label>
                                            <div className="rrs-detail-data">
                                                <input autoComplete="off" type="text" className="form-control w-500"  placeholder="ค้นหาด้วยรหัส Cost Center , ชื่อ หรือ ชื่อย่อ" id="q_costCenter" name="q_costCenter"  onChange={this.handleChange} value={q_costCenter} />
                                            </div>

                                        </div>
                                    </div>
                                   
                                    <div className="col-3">
                                        <div className="rrs-form">
                                            <label htmlFor="txtName" className="rrs-label" style={{marginBottom:'9px',width:'100%'}}>&nbsp;</label>
                                            <button className="rrs-btn-icon" onClick={this.handleClick}><i className="icon bt-search icon-xs"></i></button>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row no-gutters sp-table-content">
                                <div className="col-12">
                                    
                                    <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                        <TableHead>
                                            <TableRow className="sp-table-header">
                                                <TableCell className="th-table text-center">
                                                    Cost Center
                                                </TableCell>
                                                <TableCell className="th-table text-center">
                                                    General Name
                                                </TableCell>
                                                <TableCell className="th-table text-center">
                                                    Description
                                                </TableCell>
                                                <TableCell className="th-table text-center">
                                                    
                                                </TableCell>
                                                
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {costCenterDatas && this.stableSort(costCenterDatas, this.getSorting(this.state.order, this.state.orderBy))
                                                //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((row, index) => {
                                                    //console.log("SearchAssetModal", page)                                                    
                                                    //console.log(assetDatas)                                                    
                                                    return (
                                                        <TableRow
                                                            hover
                                                            tabIndex={-1}
                                                            key={row.cosT_CENTER}
                                                        >
                                                            <TableCell className="action-icon">
                                                                {row.cosT_CENTER}
                                                            </TableCell>
                                                            <TableCell className="action-icon text-left">
                                                                {row.generaL_NAME}
                                                            </TableCell>
                                                            <TableCell className="action-icon text-left">
                                                                {row.description}
                                                            </TableCell>
                                                            <TableCell className="action-icon">
                                                                <button className="btn btn-info btn-choose-item" aria-label="Close" onClick={() => this.selecctCostCenter(row)}>
                                                                    เลือก
                                                                </button> 
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            }
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        className="pager"
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={totalRecord}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        backIconButtonProps={{
                                            "aria-label": "previous page"
                                        }}
                                        nextIconButtonProps={{
                                            "aria-label": "next page"
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </div>

                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    const { ModalCostCenterRedux } = state
    return {
       refKey : ModalCostCenterRedux.refKey
    }
}
  
  const mapDispatchToProps = dispatch => {
    return {        
      getCostCenter: (searchCostCenter,offset,limit) => dispatch(getCostCenterAction(searchCostCenter,offset,limit)),
      startLoading: () => dispatch(startLoadingAction()),
      stopLoading: () => dispatch(stopLoadingAction()),
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(SearchCostCenterModal)